function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// src/components/switch.ts
import { switchAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, defineStyle } from "@chakra-ui/styled-system";
import { calc, cssVar } from "@chakra-ui/theme-tools";
var _createMultiStyleConf = createMultiStyleConfigHelpers(parts.keys),
  defineMultiStyleConfig = _createMultiStyleConf.defineMultiStyleConfig,
  definePartsStyle = _createMultiStyleConf.definePartsStyle;
var $width = cssVar("switch-track-width");
var $height = cssVar("switch-track-height");
var $diff = cssVar("switch-track-diff");
var diffValue = calc.subtract($width, $height);
var $translateX = cssVar("switch-thumb-x");
var $bg = cssVar("switch-bg");
var baseStyleTrack = defineStyle(function (props) {
  var c = props.colorScheme;
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    borderRadius: "full",
    p: "0.5",
    width: [$width.reference],
    height: [$height.reference],
    transitionProperty: "common",
    transitionDuration: "fast"
  }, $bg.variable, "colors.gray.300"), "_dark", _defineProperty({}, $bg.variable, "colors.whiteAlpha.400")), "_focusVisible", {
    boxShadow: "outline"
  }), "_disabled", {
    opacity: 0.4,
    cursor: "not-allowed"
  }), "_checked", _defineProperty(_defineProperty({}, $bg.variable, "colors.".concat(c, ".500")), "_dark", _defineProperty({}, $bg.variable, "colors.".concat(c, ".200")))), "bg", $bg.reference);
});
var baseStyleThumb = defineStyle({
  bg: "white",
  transitionProperty: "transform",
  transitionDuration: "normal",
  borderRadius: "inherit",
  width: [$height.reference],
  height: [$height.reference],
  _checked: {
    transform: "translateX(".concat($translateX.reference, ")")
  }
});
var baseStyle = definePartsStyle(function (props) {
  return {
    container: _defineProperty(_defineProperty(_defineProperty({}, $diff.variable, diffValue), $translateX.variable, $diff.reference), "_rtl", _defineProperty({}, $translateX.variable, calc($diff).negate().toString())),
    track: baseStyleTrack(props),
    thumb: baseStyleThumb
  };
});
var sizes = {
  sm: definePartsStyle({
    container: _defineProperty(_defineProperty({}, $width.variable, "1.375rem"), $height.variable, "sizes.3")
  }),
  md: definePartsStyle({
    container: _defineProperty(_defineProperty({}, $width.variable, "1.875rem"), $height.variable, "sizes.4")
  }),
  lg: definePartsStyle({
    container: _defineProperty(_defineProperty({}, $width.variable, "2.875rem"), $height.variable, "sizes.6")
  })
};
var switchTheme = defineMultiStyleConfig({
  baseStyle: baseStyle,
  sizes: sizes,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
});
export { switchTheme };